import { Typography } from "@material-ui/core"


const Reshcedule = (props) => {

  return ( <>
    <Typography>
      Absolutely! We get it—life happens. When you book your song, you’ll get a confirmation email with a link to reschedule if needed. Just give us at least 24 hours' notice, and you’re good to go. Need help? Reach out, and we’ll sort it out together!
    </Typography>
  </> )
}

export default Reshcedule
